import { Redirect, Route } from 'react-router-dom';
import { accessAuthState } from '../states/auth.state';

interface PrivateRoute {
  path: string;
  exact?: boolean;
  showLogin?: boolean;
  component: any;
  roles?: any;
}

export const PrivateRoute = (props: PrivateRoute) => {
  const { component: Component, roles, showLogin, ...rest } = props
  return (
    <Route {...rest} render={props => {
      if (!localStorage.getItem('access_token')) {
        return <Redirect to={{ pathname: '/', search: `${showLogin ? '?action=login' : ''}`, state: { from: props.location } }} />
      }
      return <Component {...props} />
    }} />
  )
}
